module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.currentView, {
    tag: "component",
    class: _vm.type,
    attrs: {
      "show": _vm.show,
      "confirm-text": _vm.confirmText
    },
    on: {
      "onConfirm": _vm.onConfirm,
      "onCancel": _vm.onCancel,
      "onShow": function($event) {
        _vm.$emit('onShow')
      },
      "onHide": function($event) {
        _vm.$emit('onHide')
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b79a035!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/dialog.vue
// module id = 362
// module chunks = 1